// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.view-select .w-select-button {\r\n\tbackground: rgba(255, 255, 255, 1);\r\n\tcolor: #6a757b;\r\n\tborder: 1px solid var(--main-gray-2);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
